import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
// REDUX
import { fetchSavedSearches } from 'redux/actions/thunks/SavedSearchesThunks';
import { fetchFavorites } from 'redux/actions/thunks/FavoritesThunks';
// COMPONENTS
import Login from './Login';
// LIBS
import AppStore from 'fetch/AppFetch';
import Helper from 'lib/Helper';
import AppAuth from 'AppAuth';
import AppConfig from 'appConfig';

const mapDispatchToProps = (dispatch, ownProps) => ({
  userDidLogin: () => {
    // Clear redirect tracking on successful login (only if feature is enabled)
    if (AppConfig.enableRedirectZywaveDotCom) {
      AppAuth.clearRedirectTracking();
    }

    const userinfo = AppStore.fetchUserInfo();

    const productCodes = userinfo.products.map((product) => {
      return Object.hasOwn(product, 'PC') ? 'PC' : Object.hasOwn(product, 'H-W') ? 'H-W' : '?';
    });

    if (productCodes.includes('H-W') && !productCodes.includes('PC')) {
      window.location.href = '/edge/eb';
    } else {
      window.location.href = '/edge/pc';
    }

    dispatch(fetchSavedSearches()); // Re-fetch all SavedSearches by calling a Thunks
    dispatch(fetchFavorites()); // Re-fetch all Favorites by calling a Thunks
    //dispatch( fetchUserPreference() ); // Re-fetch UserPreference by calling a Thunks

    //identify the user to sentry.io for error reporting
    if (Sentry) {
      Sentry.setUser(Helper.getSentryUserContext(userinfo));
    }
  },
});

const LoginWrapper = connect(null, mapDispatchToProps)(Login);

export default LoginWrapper;
